import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Login from './pages/LoginPage';
import RbsBbm from './pages/RbsBbm';
import RbsOperasional from './pages/RbsOperasional';
import RbsUmum from './pages/RbsUmum';
import LpjUmum from './pages/LpjUmum';
import LpjMarketing from './pages/LpjMarketing';
import DetailReimbursementPage from './pages/DetailRbsPage';
import DetailLpjPage from './pages/DetailLpjPage';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/protectedRoute';
import RbsCheckPage from './pages/RbsCheckPage';
import LpjCheckPage from './pages/LpjCheckPage';
import ManageUserPage from './pages/ManageUserPage';
import AddUserPage from './pages/AddUserPage';
import EditUserPage from './pages/EditUserPage';
import FormBsPage from './pages/BsPage';
import BsCheckPage from './pages/BsCheckPage';
import DetailBsPage from './pages/DetailBsPage';
import ReportExportPage from './pages/ReportExportPage';
import Dashboard from './pages/Dashboard';
import CatatNotaPage from './pages/CatatNotaPage';
import RekapanPage from './pages/RekapanPage';
import AnnouncementManagerPage from './pages/AnnouncementManagerPage';
import SessionTimeoutHandler from './components/SessionTimeoutHandler';
import AnnouncementPopup from './components/AnnouncementPopup';
import { ThemeProvider } from './context/ThemeContext';

const AppContent = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/';

    return (
        <SessionTimeoutHandler timeoutDuration={60 * 60 * 1000}> {/* 60 menit timeout */}
            <div>
                {!isLoginPage && <AnnouncementPopup />}
                <Routes>
                    {/* Login Routes */}
                    <Route path="/" element={<Login />} />

                    {/* Dashboard Routes */}
                    {/* Bagian AS: 'Super Admin' sebelumnya TIDAK ADA di daftar ini --
                        satu-satunya route di file ini yang lupa menyertakannya (semua
                        route lain konsisten selalu mengizinkan Super Admin). Setiap kali
                        Super Admin mengedit pengajuan orang lain lewat BsCheck.jsx/
                        ReimbursementCheck.jsx/LpjBsCheck.jsx/ReportExport.jsx lalu form-nya
                        navigate('/dashboard') setelah berhasil simpan (FormBs.jsx,
                        FormRbsBbm/Operasional/Umum.jsx, FormLpjUmum/Marketing.jsx),
                        ProtectedRoute menolak & melempar ke /404 -- data SUDAH tersimpan
                        (toast sukses sempat tampil), tapi user melihatnya seolah gagal
                        total karena langsung diarahkan ke halaman kosong. */}
                    <Route path="/dashboard" element={
                        <ProtectedRoute allowedRoles={['Admin', 'Reviewer', 'Validator', 'Employee', 'Super Admin']}>
                            <Dashboard />
                        </ProtectedRoute>
                    } />

                    <Route path="/catat-nota" element={
                        <ProtectedRoute allowedRoles={['Admin', 'Reviewer', 'Validator', 'Employee', 'Super Admin']}>
                            <CatatNotaPage />
                        </ProtectedRoute>
                    } />

                    {/* Reimbursement Routes */}
                    <Route path="/reimbursement/bbm" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <RbsBbm />
                        </ProtectedRoute>
                    } />

                    <Route path="/reimbursement/operasional" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <RbsOperasional />
                        </ProtectedRoute>
                    } />

                    <Route path="/reimbursement/umum" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <RbsUmum />
                        </ProtectedRoute>
                    } />

                    <Route path="/reimbursement/cek-pengajuan" element={
                        <ProtectedRoute allowedRoles={['Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <RbsCheckPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/reimbursement/:id" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <DetailReimbursementPage />
                        </ProtectedRoute>
                    } />

                    {/* Bon Sementara Routes */}
                    <Route path="/bon-sementara/ajukan" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <FormBsPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/bon-sementara/cek-pengajuan" element={
                        <ProtectedRoute allowedRoles={['Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <BsCheckPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/bon-sementara/:id" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <DetailBsPage />
                        </ProtectedRoute>
                    } />

                    {/* LPJ BS Routes */}
                    <Route path="/lpj/umum" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <LpjUmum />
                        </ProtectedRoute>
                    } />

                    <Route path="/lpj/marketing" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <LpjMarketing />
                        </ProtectedRoute>
                    } />

                    <Route path="/lpj/cek-pengajuan" element={
                        <ProtectedRoute allowedRoles={['Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <LpjCheckPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/lpj/:id" element={
                        <ProtectedRoute allowedRoles={['Employee', 'Reviewer', 'Validator', 'Admin', 'Super Admin']}>
                            <DetailLpjPage />
                        </ProtectedRoute>
                    } />

                    {/* User Management Routes */}
                    <Route path="/manage-users" element={
                        <ProtectedRoute allowedRoles={['Super Admin']}>
                            <ManageUserPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/manage-users/add" element={
                        <ProtectedRoute allowedRoles={['Super Admin']}>
                            <AddUserPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/manage-users/edit" element={
                        <ProtectedRoute allowedRoles={['Super Admin']}>
                            <EditUserPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/ekspor-laporan-pengajuan" element={
                        <ProtectedRoute allowedRoles={['Super Admin']}>
                            <ReportExportPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/rekapan" element={
                        <ProtectedRoute allowedRoles={['Validator', 'Admin', 'Super Admin']}>
                            <RekapanPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/manage-announcements" element={
                        <ProtectedRoute allowedRoles={['Super Admin']}>
                            <AnnouncementManagerPage />
                        </ProtectedRoute>
                    } />

                    {/* 404 Route */}
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </div>
        </SessionTimeoutHandler>
    );
}

const App = () => {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;